<template>
  <div ref="holder" class="flex-grow-1 d-flex flex-column">
    <div class="flex-grow-1"></div>
    <b-container>
      <b-row align-h="center">
        <b-col cols="12" sm="10" md="8" lg="6" xl="4">
          <b-card>
            <b-row align-h="center">
              <b-col cols="6" md="4">
                <p class="text-center h4">
                  <b-link :to="$t('home_link')">
                    <img
                      src="@/assets/synaplus_logo_square256.svg"
                      alt="Synaplus"
                    />
                  </b-link>
                </p>
              </b-col>
            </b-row>

            <p class="text-center h5">{{ $t('welcome_login') }}</p>
            <p class="text-center h6">{{ $t('access_cosmo') }}</p>
            <h6>&nbsp;</h6>
            <b-alert v-if="invalid_login_or_password" show variant="warning">{{
              $t('invalid_input')
            }}</b-alert>
            <b-form-group label-for="input-username" class="my-4">
              <slot name="label"
                ><b>{{ $t('username') }}</b></slot
              >
              <b-input-group id="input-username">
                <b-input-group-prepend is-text
                  ><span class="fas fa-user-tie fa-fw"
                /></b-input-group-prepend>
                <b-form-input
                  v-model="username"
                  type="text"
                  name="username"
                  :placeholder="$t('username')"
                />
              </b-input-group>
            </b-form-group>
            <b-form-group label-for="input-password" class="my-4">
              <slot name="label"
                ><b>{{ $t('password') }}</b></slot
              >
              <b-input-group id="input-password">
                <b-input-group-prepend is-text
                  ><span class="fas fa-key fa-fw"
                /></b-input-group-prepend>
                <b-form-input
                  v-model="password"
                  type="password"
                  name="password"
                  :placeholder="$t('password')"
                />
              </b-input-group>
            </b-form-group>
            <b-button
              class="my-4"
              variant="primary"
              :block="true"
              pill
              @click="login"
              >{{ $t('login') }}</b-button
            >
          </b-card>
          <div class="d-flex justify-content-between flex-wrap">
            <b-dropdown variant="link" size="sm">
              <template slot="button-content">{{
                $t('current_language')
              }}</template>
              <b-dropdown-item @click="set_locale('en')"
                >English (United States)</b-dropdown-item
              >
              <b-dropdown-item @click="set_locale('fr')"
                >Français (France)</b-dropdown-item
              >
            </b-dropdown>
            <!--             <b-button variant="link" size="sm" to="/help">{{
              $t('help')
            }}</b-button>
 -->
          </div>
        </b-col>
      </b-row>
    </b-container>
    <div class="flex-grow-1"></div>
  </div>
</template>

<i18n>
{
  "en": {
    "welcome_login": "Welcome, please sign in",
    "access_cosmo": "to continue to Synaplus private services",
    "invalid_input": "Invalid Username and / or Password",
    "username": "Username",
    "password": "Password",
    "login": "Sign in",
    "help": "Help",
    "current_language": "English (United States)"
  },
  "fr": {
    "welcome_login": "Bienvenue, identifiez-vous",
    "access_cosmo": "pour accéder au services privés de Synaplus",
    "invalid_input": "Nom d'utilisateur et / ou mot de passe invalide(s)",
    "username": "Nom d'utilisateur",
    "password": "Mot de passe",
    "login": "Identifiez-vous",
    "help": "Aide",
    "current_language": "Français (France)"
  }
}
</i18n>

<script>
// import $ from 'jquery'

import { mapGetters, mapState } from 'vuex'

export default {
  name: 'LoginPage',
  components: {},
  data() {
    return {
      username: '',
      password: '',
    }
  },
  computed: {
    ...mapState(['invalid_login_or_password']),
    ...mapGetters(['user_is_authenticated']),
  },
  watch: {
    user_is_authenticated(nv) {
      if (nv) {
        // console.log('redirect')
        let path = this.$route.query.redirect || '/'
        this.$router.replace(path)
      }
    },
  },
  beforeMount() {
    this.$store.commit('show_navbar_and_footer', false)
  },
  beforeDestroy() {
    this.$store.commit('show_navbar_and_footer', true)
  },
  methods: {
    login() {
      const { username, password } = this
      this.$store.dispatch('ask_for_login', { login: username, password })
    },
    set_locale(language) {
      this.$store.commit('update_locale', language)
    },
  },
}
</script>
